import React from 'react';
import KQContainer from './KQContainer';

export function Work() {
    return (
        <div className="p-4">
            <h1 className="text-center mb-4">Work Experience</h1>
            <div className="col-xl mx-auto">
                <KQContainer customCss="bg-secondary">
                    <p className="mt-0 p-0">At <a href="https://evenica.com" className="link-dark" target="_blank" rel="noopener noreferrer">Evenica</a>, I...</p>
                    <ul className="py-0">
                        <li key="evenica-work-1">Served as primary support for multiple clients, working in a full-stack capacity<span className="text-dark">*</span></li>
                        <li key="evenica-work-2">Built, improved, and maintained multiple features for clients such as SOLR search (Java) and invoice printing (JavaScript, CSS)</li>
                        <li key="evenica-work-3">Became subject matter expert for a key support client and separately for our implementation and use of a specific technology (SOLR)</li>
                        <li key="evenica-work-4">Designed and implemented processes for the support team to improve their success and efficiency, with manager approval</li>
                        <li key="evenica-work-5">Audited our in-house training on our "e4 Platform" development stack, suggesting improvements whenever possible</li>
                        <li key="evenica-work-6">Worked as a business analyst for one client post user acceptance testing to backfill missing documentation</li>
                    </ul>
                    <p className="p-0">
                        Looking back on my time at Evenica, it was a great first job for me out of college. I was given the opportunity to explore the software industry from 
                        multiple different angles, transitioning from a support/triage role into the professional services team where I helped build a project from the ground up. 
                        In my first year, one of the directors introduced me to the table at our company Christmas party as someone who would touch on everything the company 
                        worked with, and I believe that ended up being about 90% true. I had a chance to learn and improve technical skills across technologies with hands on 
                        work fixing bugs and implementing features as requested by clients. 
                    </p>
                    <p className="p-0">Programming languages directly used<span className="text-dark">**</span> include...</p>
                    <ul className="py-0">
                        <li key="evenica-tech-1">React & TypeScript</li>
                        <li key="evenica-tech-2">SQL & SQL Server</li>
                        <li key="evenica-tech-3">Angular</li>
                        <li key="evenica-tech-4">GraphQL</li>
                        <li key="evenica-tech-5">Java</li>
                        <li key="evenica-tech-6">C# / .Net</li>
                    </ul>
                    <p className="mb-0">
                        <span className="text-dark">*</span>   "full-stack" in the sense that I worked on different layers for different projects, 
                            occasionally on multiple layers per organization.
                    </p>
                    <p className="mb-0">
                        <span className="text-dark">**</span>   In order from most to least used.
                    </p>
                </KQContainer>
                <KQContainer customCss="bg-accent mt-4">
                    <p className="mt-0 p-0">
                        Prior to <a href="https://evenica.com" className="link-dark" target="_blank" rel="noopener noreferrer">Evenica</a>, 
                        my work experience consisted of...
                    </p>
                    <ul className="mb-0 py-0">
                        <li key="college-work-1">Two augmented reality (AR) applications (C#, Unity Game Engine)</li>
                        <li key="college-work-2">Contributing to an academic journal as a co-author and editor</li>
                        <li key="college-work-3">Being a key component in presentations for executives</li>
                        <li key="college-work-4">Attending conferences, giving presentations, and answering questions</li>
                    </ul>
                </KQContainer>
            </div>
        </div>
    );
}